(function () {
	const header = () => {
		$("[data-hover-opacity]").hover(
			function () {
				const id = $(this).data("hover-opacity");
				$(`[data-hover-opacity=${id}]`).addClass("opacity");
				$(this).removeClass("opacity");
			},
			function () {
				const id = $(this).data("hover-opacity");
				$(`[data-hover-opacity=${id}]`).removeClass("opacity");
			}
		);

	};

    $('.header-mega-menu__have-submenu__list a[href$="/men?filter.p.m.global.sunglasses_type=1"]').parent().css("margin-top", "20px");
    $('.header-mega-menu__have-submenu__list a[href$="/collections/sale"]').parent().css("margin-top", "20px");
    $('.header-mega-menu__have-submenu__list a[href$="/blogs/inspirations"]').parent().css("margin-top", "20px");
    
  
  
  	document.addEventListener("shopify:section:load", header);
	header();

  
})();
